// @ts-check

export const generateUtmLink = ({
  baseUrl,
  utmSource,
  utmMedium,
  utmCampaign,
  utmContent,
  utmTerm,
  type,
}) => {
  let url = baseUrl || "https://domain.com";
  if (url.endsWith("/")) {
    url = url.slice(0, -1);
  }

  const params = {};

  if (utmSource) {
    params.utm_source = utmSource;
  }

  if (utmMedium) {
    params.utm_medium = utmMedium;
  }

  if (utmCampaign) {
    params.utm_campaign = utmCampaign;
  }

  if (utmContent) {
    params.utm_content = utmContent;
  }

  if (utmTerm) {
    params.utm_term = utmTerm;
  }

  if (type === "custom") {
    return `${url}/?${new URLSearchParams(params).toString()}`;
  }

  const parts = Object.entries(params).map(([key, val]) => `${key}=${val}`).join("&");

  return `${url}/?${parts}`;
};

export const capitalize = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};
